<script setup>
import AppLayout from "@/Layouts/AppLayout.vue";
import {useHelpers} from "@/helpers";
import {Link} from "@inertiajs/inertia-vue3";

const helpers = useHelpers();
defineProps({
  projects: Array,
  purchaseOrders: Array
});

const formatDate = (timestamp, format) => {
  if (!timestamp) {
    return '';
  }
  return dayjs.tz(timestamp * 1000).format(format);
}
</script>

<template>
  <AppLayout title="Search">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        <span>Search results</span>
      </h2>
    </template>
    <div>
      <div class="mx-auto py-10 sm:px-6 lg:px-8" v-if="projects.length > 0 || purchaseOrders.length > 0">
        <div class="mb-10" v-if="projects.length > 0">
          <h3 class="text-xl font-bold mb-2">Projects <span v-if="projects.length > 0"
                                                            v-text="`(${projects.length})`"></span></h3>
          <div class="overflow-x-auto">
            <table class="min-w-full w-full text-left text-sm font-light">
              <thead class="border-b font-medium dark:border-neutral-500">
              <tr>
                <th scope="col" class="px-4 py-2">Thumbnail</th>
                <th scope="col" class="px-4 py-2">Project Name</th>
                <th scope="col" class="px-4 py-2">Company</th>
                <th scope="col" class="px-4 py-2">Project Manager</th>
                <th scope="col" class="px-4 py-2">Created At</th>
                <th scope="col" class="px-4 py-2">Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr class="border-b transition duration-300 ease-in-out" v-for="project in projects">
                <td class="px-4 py-2 break-words">
                  <img v-if="project.media_thumbnail" class="w-16"
                       :src="project.media_thumbnail.url" :alt="project.media_thumbnail.file_name">
                </td>
                <td class="px-4 py-2 break-words" v-text="project.projectname"></td>
                <td class="px-4 py-2 break-words" v-text="project.company.client"
                    :class="{'text-red-600': project.company.class === 'D'}"></td>
                <td class="px-4 py-2 break-words" v-text="project.manager?.full_name"></td>
                <td class="px-4 py-2 break-words" v-text="formatDate(project.created_date, 'MM/DD/YYYY')"></td>
                <td class="px-4 py-2 break-words">
                  <Link :href="route('admin.projects.edit', {project: project.pid})" class="fa fa-pen p-1"
                        :title="`Edit ${project.projectname}`">
                  </Link>
                </td>
              </tr>
              </tbody>
            </table>

          </div>
        </div>
        <div :class="{'mt-5': projects.length > 0}" v-if="purchaseOrders.length > 0">
          <h3 class="text-xl font-bold mb-2">Purchase Orders <span v-if="purchaseOrders.length > 0"
                                                                   v-text="`(${purchaseOrders.length})`"></span></h3>
          <div class="overflow-x-auto">
            <table class="min-w-full w-full text-left text-sm font-light">
              <thead class="border-b font-medium dark:border-neutral-500">
              <tr>
                <th scope="col" class="px-4 py-2">Thumbnail</th>
                <th scope="col" class="px-4 py-2">Project Name</th>
                <th scope="col" class="px-4 py-2">Purchase Order</th>
                <th scope="col" class="px-4 py-2">Company</th>
                <th scope="col" class="px-4 py-2">Project Manager</th>
                <th scope="col" class="px-4 py-2">Created At</th>
                <th scope="col" class="px-4 py-2">Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr class="border-b transition duration-300 ease-in-out" v-for="purchaseOrder in purchaseOrders">
                <td class="px-4 py-2 break-words">
                  <img v-if="purchaseOrder.media_thumbnail" class="w-16"
                       :src="purchaseOrder.media_thumbnail.url" :alt="purchaseOrder.media_thumbnail.file_name">
                </td>
                <td class="px-4 py-2 break-words" v-text="purchaseOrder.projectname"></td>
                <td class="px-4 py-2 break-words" v-text="purchaseOrder.purchase_order.purchaseorder"></td>
                <td class="px-4 py-2 break-words" v-text="purchaseOrder.company.client"
                    :class="{'text-red-600': purchaseOrder.company.class === 'D'}"></td>
                <td class="px-4 py-2 break-words" v-text="purchaseOrder.manager?.full_name"></td>
                <td class="px-4 py-2 break-words" v-text="formatDate(purchaseOrder.created_date, 'MM/DD/YYYY')"></td>
                <td class="px-4 py-2 break-words">
                  <Link :href="route('admin.projects.edit', {project: purchaseOrder.pid})" class="fa fa-pen p-1"
                        :title="`Edit ${purchaseOrder.projectname}`">
                  </Link>
                </td>
              </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
      <p v-if="projects.length === 0 && purchaseOrders.length === 0">No results found, or Search query is empty</p>
    </div>
  </AppLayout>
</template>
